import { HttpError } from "ra-core";
import { fetchUtils } from "react-admin";
import { getAuth0Client } from "../auth/authProvider";

const getAuthToken = async (): Promise<string | null> => {
  try {
    const auth0Client = getAuth0Client();

    return await auth0Client.getTokenSilently();
  } catch (error) {
    console.error("Error retrieving Auth0 token", error);
    return null;
  }
};

export default async (
  url: string,
  options: fetchUtils.Options = {},
): Promise<{
  status: number;
  headers: Headers;
  body: string;
  json: Record<string, unknown>;
}> => {
  const customHeaders = (options.headers ||
    new Headers({ Accept: "application/json" })) as Headers;

  const token = await getAuthToken();

  if (token) {
    customHeaders.set("Babylone-Auth", `Bearer ${token}`);
  }

  options.headers = customHeaders;

  try {
    return await fetchUtils.fetchJson(url, options);
  } catch (e: unknown) {
    const details = (e as HttpError)?.message || (e as HttpError)?.body;
    throw new Error(`Error while running api call : ${details}`);
  }
};
